import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import BetDetails from './BetDetails';
import { games } from '../../../games/config';
import styles from './assets/styles.scss';
import { assetIcons } from '../../../config';

const cx = classNames.bind(styles);

const thirdPartyGames = ['slots', 'table', 'casual'];

export default function HistoryTableRow({
  gameCode,
  gameId,
  payoutRate,
  area,
  result,
  txId,
  betAmount,
  isWin,
  status,
  payout,
  payoutTxId,
  asset,
  txIdForUrl,
  gameName,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const formattedPayoutRate = `${payoutRate?.toFixed(2) || '0.00'}x`;
  const formattedPick = games[gameCode].formatPick?.(area);
  const formattedResult = result && games[gameCode].formatResult(result);

  return (
    <tr className={cx('small')} onClick={() => setIsOpen(!isOpen)}>
      <td className={cx({ 'hide-mobile': thirdPartyGames.includes(gameCode) })}>{gameId || '-'}</td>
      {gameName && <td>{gameName}</td>}
      <td className={cx('bet-amount')}>
        <span className={cx('small')}>{betAmount}</span>
        {assetIcons[asset]({})}
      </td>
      {gameCode !== 'bitto' && (
        <td className={cx({ 'hide-mobile': thirdPartyGames.includes(gameCode) })}>{formattedPayoutRate}</td>
      )}
      {!thirdPartyGames.includes(gameCode) && <td className={cx('hide-mobile')}>{formattedPick}</td>}
      {!thirdPartyGames.includes(gameCode) && <td className={cx('hide-mobile')}>{formattedResult || '-'}</td>}
      <td>
        <BetDetails
          isOpen={thirdPartyGames.includes(gameCode) ? false : isOpen}
          onClose={() => setIsOpen(false)}
          gameCode={gameCode}
          isWin={isWin === 'Y'}
          status={status}
          betAmount={betAmount}
          payout={payout}
          payoutRate={formattedPayoutRate}
          txId={txId}
          playerPick={formattedPick}
          result={formattedResult}
          payoutTxId={payoutTxId}
          asset={asset}
          txIdForUrl={txIdForUrl}
        />
      </td>
    </tr>
  );
}
HistoryTableRow.propTypes = {
  gameId: PropTypes.number.isRequired,
  isWin: PropTypes.string,
  status: PropTypes.string.isRequired,
  betAmount: PropTypes.number.isRequired,
  payout: PropTypes.number,
  payoutRate: PropTypes.number,
  gameCode: PropTypes.string.isRequired,
  area: PropTypes.string.isRequired,
  result: PropTypes.string.isRequired,
  txId: PropTypes.string.isRequired,
  payoutTxId: PropTypes.string,
  asset: PropTypes.string.isRequired,
  txIdForUrl: PropTypes.string.isRequired,
  gameName: PropTypes.string,
};
HistoryTableRow.defaultProps = {
  payout: null,
  payoutTxId: null,
  payoutRate: null,
  isWin: null,
  gameName: null,
};
